import { useState } from "react";
import { MapPin, ChevronDown } from "lucide-react";
import { getCity, setCity } from "@/lib/city";

export const LocationSelector = ({ cities = [] }) => {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(getCity());

  const pick = (label) => {
    setCity(label);
    setCurrent(label);
    setOpen(false);
  };

  return (
    <div className="relative">
      <button
        type="button"
        data-testid="city-selector-button"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3.5 py-2 text-sm font-medium text-slate-700 transition hover:border-blue-300"
      >
        <MapPin className="h-4 w-4 text-[#2563EB]" />
        <span className="hidden sm:inline">{current.split(",")[0]}</span>
        <ChevronDown className={`h-3.5 w-3.5 text-slate-400 transition ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div
            data-testid="city-selector-menu"
            className="absolute right-0 z-50 mt-2 w-44 overflow-hidden rounded-2xl border border-slate-100 bg-white p-1.5 shadow-xl"
          >
            {cities.map((c) => (
              <button
                key={c.slug}
                type="button"
                data-testid={`city-option-${c.slug}`}
                onClick={() => pick(c.label)}
                className={`flex w-full items-center rounded-xl px-3 py-2 text-left text-sm transition hover:bg-blue-50 ${
                  current === c.label ? "font-semibold text-[#2563EB]" : "text-slate-700"
                }`}
              >
                {c.name}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
